var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.10297 10.6638C3.10297 15.1678 6.75404 18.8194 11.2582 18.8194C15.7618 18.8194 19.4135 15.1678 19.4135 10.6638C19.4135 6.15976 15.7618 2.50883 11.2582 2.50883C6.75404 2.50883 3.10297 6.15976 3.10297 10.6638ZM0.949951 10.6638C0.949951 4.97099 5.56547 0.355469 11.2582 0.355469C16.9517 0.355469 21.5665 4.97099 21.5665 10.6638C21.5665 16.3565 16.9517 20.972 11.2582 20.972C5.56547 20.972 0.949951 16.3565 0.949951 10.6638Z",
    fill: "#303A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1016 11.0258C12.2619 11.6265 11.8796 12.2136 11.9479 12.787V13.1898H10.132V12.6369C10.1231 11.6859 10.5989 10.7957 11.3949 10.2748C12.2619 9.63994 12.6852 9.04602 12.651 8.51354C12.6435 7.83907 12.0906 7.29771 11.4154 7.30522H11.4086C10.6153 7.2861 9.91149 7.81039 9.70192 8.57498C9.5763 8.86785 9.26433 9.0351 8.95098 8.97776L8.23418 8.81392C7.87032 8.71425 7.65596 8.33878 7.75563 7.97492L7.75631 7.97423C8.30722 6.29487 9.62409 5.48454 11.709 5.54394C13.6525 5.64429 14.7086 6.5338 14.8765 8.21317C14.9448 9.287 14.3577 10.225 13.1153 11.0258H13.1016Z",
    fill: "#303A3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5892 14.1455H11.4903C11.8521 14.1455 12.1457 14.4391 12.1457 14.8009V15.5518C12.1457 15.9136 11.8521 16.2078 11.4903 16.2078H10.5892C10.2274 16.2078 9.93384 15.9136 9.93384 15.5518V14.8009C9.93384 14.4391 10.2274 14.1455 10.5892 14.1455Z",
    fill: "#303A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.b9b901b244c5af056a5d196001bedf0b.svg";
export { ForwardRef as ReactComponent };